'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_CLASS_PREFIX = "t";
var DEFAULT_LOCALE = "zh-CN";
var ConfigContext = {
  classPrefix: DEFAULT_CLASS_PREFIX,
  locale: DEFAULT_LOCALE
};

exports.DEFAULT_CLASS_PREFIX = DEFAULT_CLASS_PREFIX;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports["default"] = ConfigContext;
//# sourceMappingURL=config-context.js.map
